import React from "react";
import { useTheme } from "styled-components";

const People = () => {
  const theme = useTheme();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.213 10.575a.563.563 0 0 1-.788-.112A3.63 3.63 0 0 0 13.5 9a.563.563 0 0 1 0-1.125 1.687 1.687 0 1 0-1.634-2.11.562.562 0 1 1-1.09-.28 2.813 2.813 0 1 1 4.622 2.777c.765.332 1.43.857 1.93 1.525a.56.56 0 0 1-.116.788m-3.789 4.331a.562.562 0 1 1-.973.563 4.007 4.007 0 0 0-6.902 0 .562.562 0 1 1-.973-.563 5.07 5.07 0 0 1 2.372-2.104 3.375 3.375 0 1 1 4.104 0 5.07 5.07 0 0 1 2.372 2.104M9 12.375a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5M5.062 8.438a.56.56 0 0 0-.562-.563 1.687 1.687 0 1 1 1.634-2.11.563.563 0 0 0 1.09-.28 2.813 2.813 0 1 0-4.622 2.777A4.8 4.8 0 0 0 .675 9.787a.563.563 0 0 0 .9.675A3.63 3.63 0 0 1 4.5 9a.563.563 0 0 0 .562-.562"
        fill={theme.text.text}
      />
    </svg>
  );
};

export default People;
